module.exports = __webpack_public_path__ + "fonts/Inter-italic.var.2690e3c.woff2";